import { FC } from "react";
import logo from "../../../assets/images/landing/logo.png";
import "./styles.scss";

export const Logo: FC = () => (
  <img src={logo} alt="connectyid" className="landing-logo" />
);
